import axios from 'axios'

axios.defaults.baseURL = API_BASE_URL

export default axios
